import React from "react";
import { ConfigProvider, Spin } from "antd";

const Loader = ({ size = "large", color = "orange", height = "100%" }) => (
  <ConfigProvider
    theme={{
      token: {
        colorPrimary: "orange",
      },
    }}
  >
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        width: "100%",
        height: height,
        zIndex: 2000,
      }}
    >
      <div style={{ marginBottom: "50px" }}>
        <Spin size={size} color={color} colorPrimary="orange" />
      </div>
    </div>
  </ConfigProvider>
);

export default Loader;
